<template>
  <div class="list-container">
    <b-loading :is-full-page="false" :active.sync="$store.state.isSearching"/>

    <b-table
      :data="kycList"

      paginated
      backend-pagination
      pagination-simple
      :total="totalForms"
      :per-page="formsPerPage"
      :current-page="currentPage"
      @page-change="onPageChange"

      :default-sort-direction="defaultSortDirection"
      default-sort="date_modified"

      hoverable
      focusable
      :selected.sync="selected"
    >
    <template slot-scope="props">
      <b-table-column sortable width="20" field="status">
        <span class="completed">
          {{ props.row.is_completed || props.row.status > 10 ? '✓' : '' }}
        </span>
      </b-table-column>

      <b-table-column field="name" label="Company" sortable>
        <router-link :to="`/kyc/${props.row.id}`">
          {{props.row.name}}
        </router-link>
      </b-table-column>

      <b-table-column field="job_number" label="Job" sortable>
        {{props.row.job_number}}
      </b-table-column>

      <b-table-column field="file_manager_id" label="File Manager" sortable>
        {{$store.getters.getStaffNameById(props.row.file_manager_id)}}
      </b-table-column>

      <b-table-column field="date_modified" label="Modified" sortable>
        {{formatDate(props.row.date_modified)}}
      </b-table-column>
    </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'KycList',
  props: ['kycList'],
  data () {
    return {
      defaultSortDirection: 'desc',
      selected: null
    }
  },
  computed: {
    ...mapState([
      'searched',
      'totalForms',
      'currentPage',
      'formsPerPage'
    ])
  },
  methods: {
    formatDate (date) {
      return moment(date).fromNow()
    },
    onPageChange (page) {
      this.$store.dispatch('setCurrentPage', { page })
      if (this.searched) {
        this.$store.dispatch('searchKyc')
      } else {
        this.$store.dispatch('getKycList')
      }
    }
  }
}
</script>

<style scoped>
.list-container {
  margin: 2em 0;
  position: relative;
}

</style>
